(function () {
  const WRAP_SEL = '.ts-flota-propia-wrap';

  // Comunas habilitadas
  const comunas = new Set([
    "Cerrillos","Estación Central","Maipú","Cerro Navia","Lo Prado","Pudahuel",
    "Pedro Aguirre Cerda","La Reina","Las Condes","Lo Barnechea","Macul","Peñalolén",
    "Vitacura","Independencia","Ñuñoa","Providencia","Quinta Normal","Recoleta",
    "San Joaquín","Santiago","El Bosque","La Cisterna","La Florida","La Granja",
    "La Pintana","Lo Espejo","Puente Alto","San Bernardo","San Ramón"
  ]);

  function getChileParts() {
    try {
      const fmt = new Intl.DateTimeFormat('es-CL', {
        timeZone: 'America/Santiago',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      });
      const parts = fmt.formatToParts(new Date());
      const hh = Number(parts.find(p => p.type === 'hour')?.value);
      const wd = (parts.find(p => p.type === 'weekday')?.value || '').toLowerCase();
      return { hh, wd };
    } catch (e) {
      const d = new Date();
      return { hh: d.getHours(), wd: d.toLocaleString('es-CL', { weekday: 'short' }).toLowerCase() };
    }
  }

  function eligible() {
    const region = (localStorage.getItem('region') || '').trim(); // "RM"
    const comuna = (localStorage.getItem('comuna') || '').trim();
    return region === 'RM' && comunas.has(comuna);
  }

  function pickText(root) {
    const cutoff = Number(root.dataset.cutoffHour || 14);
    const textToday = root.dataset.textToday || 'Llega hoy por flota propia';
    const textTomorrow = root.dataset.textTomorrow || 'Llega mañana por flota propia';
    const textMonday = root.dataset.textMonday || 'Llega el lunes por flota propia';

    const { hh, wd } = getChileParts();
    const isFri = wd.startsWith('vie');
    const isSat = wd.startsWith('sáb') || wd.startsWith('sab');

    if (isSat) return textMonday;
    if (isFri && hh >= cutoff) return textMonday;
    if (hh >= cutoff) return textTomorrow;
    return textToday;
  }

  function applyStylesOnce(textEl) {
    if (textEl.dataset.tsStyled === '1') return;
    textEl.dataset.tsStyled = '1';

    // Badge tipo pill (similar a envío gratis)
    textEl.style.display = 'inline-flex';
    textEl.style.alignItems = 'center';
    textEl.style.justifyContent = 'center';
    textEl.style.background = '#000';
    textEl.style.color = '#fff';
    textEl.style.padding = '7px 12px';
    textEl.style.borderRadius = '999px';
    textEl.style.fontSize = '12px';
    textEl.style.lineHeight = '1';
    textEl.style.fontWeight = '700';
    textEl.style.textTransform = 'uppercase';
    textEl.style.letterSpacing = '.2px';
  }

  function renderAll() {
    const wraps = document.querySelectorAll(WRAP_SEL);
    if (!wraps.length) return;

    const ok = eligible();

    wraps.forEach(root => {
      const textEl = root.querySelector('.ts-flota-propia-text');
      if (!textEl) return;

      if (!ok) {
        root.style.display = 'none';
        return;
      }

      textEl.textContent = pickText(root);
      applyStylesOnce(textEl);
      root.style.display = 'block';
    });
  }

  // Debounce para evitar múltiples ejecuciones seguidas
  let t = null;
  function scheduleRender() {
    if (t) clearTimeout(t);
    t = setTimeout(renderAll, 150);
  }

  // 1) Inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll, { once: true });
  } else {
    renderAll();
  }

  // 2) Cambios manuales en selectors (ya lo tenías, se mantiene)
  document.addEventListener('change', (e) => {
    const id = e.target?.id;
    if (id === 'header-select-city' || id === 'header-select-town' || id === 'select-city' || id === 'select-town') {
      scheduleRender();
    }
  });

  // 3) Cambios de variante / producto (según theme: Dawn y otros disparan estos eventos)
  document.addEventListener('variant:change', scheduleRender);
  document.addEventListener('product:change', scheduleRender);

  // 4) Shopify editor / secciones (cuando se re-renderiza el DOM del producto)
  document.addEventListener('shopify:section:load', scheduleRender);
  document.addEventListener('shopify:section:select', scheduleRender);

  // 5) Navegación sin recarga (back/forward, bfcache)
  window.addEventListener('popstate', scheduleRender);
  window.addEventListener('pageshow', scheduleRender);

  // 6) Observador ACOTADO al contenedor del producto (evita saturación)
  // Si tu theme reemplaza HTML del producto por AJAX, esto reencuentra el wrap sin observar todo el documento.
  const productRoot =
    document.querySelector('main') ||
    document.querySelector('.main-content') ||
    document.querySelector('body');

  if (productRoot) {
    let moTick = null;
    const mo = new MutationObserver(() => {
      // throttle: 1 vez cada 200ms máximo
      if (moTick) return;
      moTick = setTimeout(() => {
        moTick = null;
        renderAll();
      }, 200);
    });
    mo.observe(productRoot, { childList: true, subtree: true });
  }
})();
